<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-111">
<div class="calibre1">
<p class="normal-229-0-override1"><span class="no-style-override1"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal-229-0-override"><span class="no-style-override2">Other Books By Kevin Sullivan</span></p>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-3">The Bundy Secrets: Hidden Files on America’s Worst Serial Killer</span></h3>
<h3 class="normal-229-0-override"><a href="http://wbp.bz/bundysecrets" target="_blank">wbp.bz/bundysecrets</a><br/></h3>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-3">Kentucky Bloodbath</span></h3>
<h3 class="normal-229-0-override"><a href="http://wbp.bz/kb" target="_blank">wbp.bz/kb</a><br/></h3>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-2"><br/></span></h3>
<h3 class="normal-229-0-override"><span class="sgc-3">VAMPIRE: The Richard Chase Murders</span></h3>
<p class="normal-229-0-override"></p>
<h3 class="normal-229-0-override"><a href="http://wbp.bz/vampire" target="_blank">wbp.bz/vampire</a><br/></h3>
<div class="sgc-4">
<br/>
</div>
<p class="calibre2" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherbooksby.vue?615fff4a